/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type ProductsCatalog_viewer$ref = any;
export type ProductCatalog_QueryVariables = {
    readonly count?: number | null;
    readonly category?: string | null;
    readonly sortBy?: string | null;
    readonly filterPrice?: ReadonlyArray<string | null> | null;
    readonly filterByCause?: ReadonlyArray<string | null> | null;
    readonly filterByType?: ReadonlyArray<string | null> | null;
    readonly filterByVarietal?: ReadonlyArray<string | null> | null;
    readonly filterByGiftCategories?: ReadonlyArray<string | null> | null;
    readonly productCategories?: ReadonlyArray<string | null> | null;
    readonly productsExclude?: ReadonlyArray<string | null> | null;
    readonly productsOnly?: ReadonlyArray<string | null> | null;
};
export type ProductCatalog_QueryResponse = {
    readonly viewer: ({
        readonly id: string | null;
        readonly " $fragmentRefs": ProductsCatalog_viewer$ref;
    }) | null;
};
export type ProductCatalog_Query = {
    readonly response: ProductCatalog_QueryResponse;
    readonly variables: ProductCatalog_QueryVariables;
};



/*
query ProductCatalog_Query(
  $count: Int
  $category: String
  $sortBy: String
  $filterPrice: [String]
  $filterByCause: [String]
  $filterByType: [String]
  $filterByVarietal: [String]
  $filterByGiftCategories: [String]
  $productCategories: [String]
  $productsExclude: [String]
  $productsOnly: [String]
) {
  viewer {
    id
    ...ProductsCatalog_viewer_4muyEu
  }
}

fragment ProductsCatalog_viewer_4muyEu on Viewer {
  id
  productsBulk(first: 2, productIds: ["4f3661e6-9d11-43bc-872e-6f4cc1df744f", "7e86bc10-4203-4078-a006-ba8394422f20"]) {
    edges {
      node {
        id
        productId
        priceSale
        images {
          productCatalog
          id
        }
        price
        productPermissions {
          oneCommerce {
            preferredCustomer {
              add
            }
          }
        }
      }
    }
  }
  user {
    id
    userId
    ...ProductListItem_user
    conciergeUser {
      id
      permissions {
        id
        oneCommerce {
          id
          preferredCustomer {
            access
          }
        }
      }
    }
    permissions {
      id
      oneCommerce {
        id
        ceo {
          access
        }
        preferredCustomer {
          access
        }
      }
    }
    conciergeCustomerAccountId
    shoppingWithCeoUser {
      id
      userId
      firstName
      lastName
      profile {
        id
        image
      }
    }
    email
    role
    products(first: $count, category: $category, sortBy: $sortBy, filterPrice: $filterPrice, filterByCause: $filterByCause, filterByType: $filterByType, filterByVarietal: $filterByVarietal, filterByGiftCategories: $filterByGiftCategories, productCategories: $productCategories, productsExclude: $productsExclude, productsOnly: $productsOnly) {
      edges {
        cursor
        node {
          id
          productId
          name
          company
          price
          priceSale
          inStockOn
          inventoryClass
          inventoryQuantity
          inventorySKU
          reviewAverage
          productURLslug
          optionsId
          ranking
          promoCodeDiscount {
            case4Cause {
              case12PriceUSD
              case6PriceUSD
              case6SKU
              case12SKU
              donationEligible
            }
          }
          options {
            id
            optionId
            optionName
            choiceStyle
            options {
              optionName
            }
          }
          images {
            productCatalog
            id
          }
          content {
            summary
            impactSmall
            id
          }
          ...ProductListItem_product
          __typename
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
    cart {
      id
      eventId
      enrollingAsPc
      taxRate
      taxTotal
      totalNumberOfItems
      subTotalPriceOfItems
      promoCodeSavings
      viaQualifiedCartTotal
      subTotalPriceOfItemsWithPromoCodes
      entries(first: 1000) {
        edges {
          node {
            id
            product {
              id
              name
              productId
              price
              priceSale
              promoCodeDiscount {
                case4Cause {
                  case12PriceUSD
                  case6PriceUSD
                  case6SKU
                  case12SKU
                  donationEligible
                }
              }
            }
            quantity
            __typename
          }
          cursor
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
      entriesV2(first: 1000) {
        edges {
          node {
            id
            quantity
            product {
              productId
              name
              id
              price
              finalPrice
              images {
                productCatalog
                productFront
                productBack
                id
              }
              productPermissions {
                oneCommerce {
                  preferredCustomer {
                    view
                    add
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

fragment ProductListItem_user on User {
  id
  role
  conciergeCustomerAccountId
  conciergeUser {
    id
    userId
    permissions {
      id
      oneCommerce {
        id
        preferredCustomer {
          access
        }
      }
    }
    subscriptions {
      wineClub {
        enrollmentStatus
        subscriptionStatus
        id
      }
      id
    }
  }
  cartV2 {
    id
    cartId
    discountQualifiedCartTotal
    entries(first: 1000) {
      edges {
        node {
          id
          sku
          productId
          quantity
          productName
          productURLslug
          productImageUrl
          wineBottleQuantity
          isWinePack
          priceOriginal
          priceSale
          priceDiscount
          discountEligible
          priceDiscountPercent
          hasQualifyingDiscount
        }
      }
    }
  }
  subscriptions {
    wineClub {
      enrollmentStatus
      subscriptionStatus
      id
    }
    id
  }
  permissions {
    id
    oneCommerce {
      id
      preferredCustomer {
        access
      }
    }
  }
}

fragment ProductListItem_product on Product {
  id
  isSubscription
  productPermissions {
    oneCommerce {
      preferredCustomer {
        view
        add
      }
      default {
        view
        add
      }
    }
  }
  ranking
  company
  freeUpsGroundShipping
  productId
  name
  category
  price
  priceUSDmin
  priceUSDmax
  year
  priceSale
  reviewAverage
  productURLslug
  parentProduct
  inventoryText
  reviewTotal
  staticUrl
  images {
    productCatalog
    squareFront
    id
  }
  content {
    impactSmall
    summary
    id
  }
  promoCodeDiscount {
    case4Cause {
      case12PriceUSD
      case6PriceUSD
      case6SKU
      case12SKU
      donationEligible
    }
  }
  inventoryClass
  inventorySKU
  inventoryQuantity
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "count",
            "type": "Int",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "category",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "sortBy",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "filterPrice",
            "type": "[String]",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "filterByCause",
            "type": "[String]",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "filterByType",
            "type": "[String]",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "filterByVarietal",
            "type": "[String]",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "filterByGiftCategories",
            "type": "[String]",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "productCategories",
            "type": "[String]",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "productsExclude",
            "type": "[String]",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "productsOnly",
            "type": "[String]",
            "defaultValue": null
        } as any)
    ], v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "productId",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "priceSale",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "productCatalog",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "price",
        "args": null,
        "storageKey": null
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "add",
        "args": null,
        "storageKey": null
    } as any), v7 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "subscriptions",
        "storageKey": null,
        "args": null,
        "concreteType": "Subscriptions",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "wineClub",
                "storageKey": null,
                "args": null,
                "concreteType": "WineClubType",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "enrollmentStatus",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "subscriptionStatus",
                        "args": null,
                        "storageKey": null
                    },
                    (v1 /*: any*/)
                ]
            },
            (v1 /*: any*/)
        ]
    } as any), v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "userId",
        "args": null,
        "storageKey": null
    } as any), v9 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "access",
            "args": null,
            "storageKey": null
        } as any)
    ], v10 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "preferredCustomer",
        "storageKey": null,
        "args": null,
        "concreteType": "AccessType",
        "plural": false,
        "selections": (v9 /*: any*/)
    } as any), v11 = [
        ({
            "kind": "Literal",
            "name": "first",
            "value": 1000,
            "type": "Int"
        } as any)
    ], v12 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "quantity",
        "args": null,
        "storageKey": null
    } as any), v13 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "productURLslug",
        "args": null,
        "storageKey": null
    } as any), v14 = [
        ({
            "kind": "Variable",
            "name": "category",
            "variableName": "category",
            "type": "String"
        } as any),
        ({
            "kind": "Variable",
            "name": "filterByCause",
            "variableName": "filterByCause",
            "type": "[String]"
        } as any),
        ({
            "kind": "Variable",
            "name": "filterByGiftCategories",
            "variableName": "filterByGiftCategories",
            "type": "[String]"
        } as any),
        ({
            "kind": "Variable",
            "name": "filterByType",
            "variableName": "filterByType",
            "type": "[String]"
        } as any),
        ({
            "kind": "Variable",
            "name": "filterByVarietal",
            "variableName": "filterByVarietal",
            "type": "[String]"
        } as any),
        ({
            "kind": "Variable",
            "name": "filterPrice",
            "variableName": "filterPrice",
            "type": "[String]"
        } as any),
        ({
            "kind": "Variable",
            "name": "first",
            "variableName": "count",
            "type": "Int"
        } as any),
        ({
            "kind": "Variable",
            "name": "productCategories",
            "variableName": "productCategories",
            "type": "[String]"
        } as any),
        ({
            "kind": "Variable",
            "name": "productsExclude",
            "variableName": "productsExclude",
            "type": "[String]"
        } as any),
        ({
            "kind": "Variable",
            "name": "productsOnly",
            "variableName": "productsOnly",
            "type": "[String]"
        } as any),
        ({
            "kind": "Variable",
            "name": "sortBy",
            "variableName": "sortBy",
            "type": "String"
        } as any)
    ], v15 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "cursor",
        "args": null,
        "storageKey": null
    } as any), v16 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "optionName",
        "args": null,
        "storageKey": null
    } as any), v17 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v18 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "promoCodeDiscount",
        "storageKey": null,
        "args": null,
        "concreteType": "PromoCodeDiscount",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "case4Cause",
                "storageKey": null,
                "args": null,
                "concreteType": "Case4Cause",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "case12PriceUSD",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "case6PriceUSD",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "case6SKU",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "case12SKU",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "donationEligible",
                        "args": null,
                        "storageKey": null
                    }
                ]
            }
        ]
    } as any), v19 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "view",
            "args": null,
            "storageKey": null
        } as any),
        (v6 /*: any*/)
    ], v20 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "preferredCustomer",
        "storageKey": null,
        "args": null,
        "concreteType": "ProductPermissionsAccess",
        "plural": false,
        "selections": (v19 /*: any*/)
    } as any), v21 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "__typename",
        "args": null,
        "storageKey": null
    } as any), v22 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "hasNextPage",
        "args": null,
        "storageKey": null
    } as any), v23 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "endCursor",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "ProductCatalog_Query",
            "type": "Root",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "kind": "FragmentSpread",
                            "name": "ProductsCatalog_viewer",
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "category",
                                    "variableName": "category",
                                    "type": null
                                },
                                {
                                    "kind": "Variable",
                                    "name": "count",
                                    "variableName": "count",
                                    "type": null
                                },
                                {
                                    "kind": "Variable",
                                    "name": "filterByCause",
                                    "variableName": "filterByCause",
                                    "type": null
                                },
                                {
                                    "kind": "Variable",
                                    "name": "filterByGiftCategories",
                                    "variableName": "filterByGiftCategories",
                                    "type": null
                                },
                                {
                                    "kind": "Variable",
                                    "name": "filterByType",
                                    "variableName": "filterByType",
                                    "type": null
                                },
                                {
                                    "kind": "Variable",
                                    "name": "filterByVarietal",
                                    "variableName": "filterByVarietal",
                                    "type": null
                                },
                                {
                                    "kind": "Variable",
                                    "name": "filterPrice",
                                    "variableName": "filterPrice",
                                    "type": null
                                },
                                {
                                    "kind": "Variable",
                                    "name": "productCategories",
                                    "variableName": "productCategories",
                                    "type": null
                                },
                                {
                                    "kind": "Variable",
                                    "name": "productsExclude",
                                    "variableName": "productsExclude",
                                    "type": null
                                },
                                {
                                    "kind": "Variable",
                                    "name": "productsOnly",
                                    "variableName": "productsOnly",
                                    "type": null
                                },
                                {
                                    "kind": "Variable",
                                    "name": "sortBy",
                                    "variableName": "sortBy",
                                    "type": null
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "ProductCatalog_Query",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "productsBulk",
                            "storageKey": "productsBulk(first:2,productIds:[\"4f3661e6-9d11-43bc-872e-6f4cc1df744f\",\"7e86bc10-4203-4078-a006-ba8394422f20\"])",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 2,
                                    "type": "Int"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "productIds",
                                    "value": [
                                        "4f3661e6-9d11-43bc-872e-6f4cc1df744f",
                                        "7e86bc10-4203-4078-a006-ba8394422f20"
                                    ],
                                    "type": "[String]"
                                }
                            ],
                            "concreteType": "ProductConnection",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ProductEdge",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "node",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Product",
                                            "plural": false,
                                            "selections": [
                                                (v1 /*: any*/),
                                                (v2 /*: any*/),
                                                (v3 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "images",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Images",
                                                    "plural": false,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        (v1 /*: any*/)
                                                    ]
                                                },
                                                (v5 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "productPermissions",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "ProductPermissions",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "oneCommerce",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "AppProductPermissionsAccess",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "preferredCustomer",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "ProductPermissionsAccess",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v6 /*: any*/)
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                (v7 /*: any*/),
                                (v1 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "role",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "conciergeCustomerAccountId",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "conciergeUser",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        (v1 /*: any*/),
                                        (v8 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "permissions",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PermissionsType",
                                            "plural": false,
                                            "selections": [
                                                (v1 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "oneCommerce",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "OneCommerceType",
                                                    "plural": false,
                                                    "selections": [
                                                        (v1 /*: any*/),
                                                        (v10 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        },
                                        (v7 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "cartV2",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "CartV2",
                                    "plural": false,
                                    "selections": [
                                        (v1 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "cartId",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "discountQualifiedCartTotal",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "entries",
                                            "storageKey": "entries(first:1000)",
                                            "args": (v11 /*: any*/),
                                            "concreteType": "CartEntryV3Connection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "edges",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "CartEntryV3Edge",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "node",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "CartEntryV3",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "wineBottleQuantity",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                (v1 /*: any*/),
                                                                (v2 /*: any*/),
                                                                (v12 /*: any*/),
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "productName",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                (v13 /*: any*/),
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "productImageUrl",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "sku",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "isWinePack",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "priceOriginal",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                (v3 /*: any*/),
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "priceDiscount",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "discountEligible",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "priceDiscountPercent",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "hasQualifyingDiscount",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                (v8 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "permissions",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PermissionsType",
                                    "plural": false,
                                    "selections": [
                                        (v1 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "oneCommerce",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "OneCommerceType",
                                            "plural": false,
                                            "selections": [
                                                (v1 /*: any*/),
                                                (v10 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "ceo",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "AccessType",
                                                    "plural": false,
                                                    "selections": (v9 /*: any*/)
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "shoppingWithCeoUser",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        (v1 /*: any*/),
                                        (v8 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "firstName",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "lastName",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "profile",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Profile",
                                            "plural": false,
                                            "selections": [
                                                (v1 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "image",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "email",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "products",
                                    "storageKey": null,
                                    "args": (v14 /*: any*/),
                                    "concreteType": "ProductConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ProductEdge",
                                            "plural": true,
                                            "selections": [
                                                (v15 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Product",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "options",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "ProductOptions",
                                                            "plural": false,
                                                            "selections": [
                                                                (v1 /*: any*/),
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "optionId",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                (v16 /*: any*/),
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "choiceStyle",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "options",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "ProductOptions",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        (v16 /*: any*/)
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        (v1 /*: any*/),
                                                        (v17 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "company",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v5 /*: any*/),
                                                        (v3 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "inStockOn",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "inventoryClass",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "inventoryQuantity",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "inventorySKU",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "reviewAverage",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v13 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "optionsId",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "ranking",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v18 /*: any*/),
                                                        (v2 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "images",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "Images",
                                                            "plural": false,
                                                            "selections": [
                                                                (v4 /*: any*/),
                                                                (v1 /*: any*/),
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "squareFront",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "content",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "Content",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "summary",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "impactSmall",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                (v1 /*: any*/)
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "isSubscription",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "productPermissions",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "ProductPermissions",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "oneCommerce",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "AppProductPermissionsAccess",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v20 /*: any*/),
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "default",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "ProductPermissionsAccess",
                                                                            "plural": false,
                                                                            "selections": (v19 /*: any*/)
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "freeUpsGroundShipping",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "category",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "priceUSDmin",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "priceUSDmax",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "year",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "parentProduct",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "inventoryText",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "reviewTotal",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "staticUrl",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v21 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "pageInfo",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PageInfo",
                                            "plural": false,
                                            "selections": [
                                                (v22 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "hasPreviousPage",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "startCursor",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v23 /*: any*/)
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedHandle",
                                    "alias": null,
                                    "name": "products",
                                    "args": (v14 /*: any*/),
                                    "handle": "connection",
                                    "key": "ProductsCatalog_products",
                                    "filters": [
                                        "category",
                                        "sortBy",
                                        "filterPrice",
                                        "filterByCause",
                                        "filterByType",
                                        "filterByVarietal",
                                        "filterByGiftCategories",
                                        "productCategories",
                                        "productsExclude",
                                        "productsOnly"
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "cart",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Cart",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "subTotalPriceOfItems",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v1 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "enrollingAsPc",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "taxRate",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "taxTotal",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "totalNumberOfItems",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "eventId",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "promoCodeSavings",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "viaQualifiedCartTotal",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "subTotalPriceOfItemsWithPromoCodes",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "entries",
                                            "storageKey": "entries(first:1000)",
                                            "args": (v11 /*: any*/),
                                            "concreteType": "CartEntryV3Connection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "edges",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "CartEntryV3Edge",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "node",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "CartEntryV3",
                                                            "plural": false,
                                                            "selections": [
                                                                (v1 /*: any*/),
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "product",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "Product",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v1 /*: any*/),
                                                                        (v17 /*: any*/),
                                                                        (v2 /*: any*/),
                                                                        (v5 /*: any*/),
                                                                        (v3 /*: any*/),
                                                                        (v18 /*: any*/)
                                                                    ]
                                                                },
                                                                (v12 /*: any*/),
                                                                (v21 /*: any*/)
                                                            ]
                                                        },
                                                        (v15 /*: any*/)
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "pageInfo",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        (v23 /*: any*/),
                                                        (v22 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedHandle",
                                            "alias": null,
                                            "name": "entries",
                                            "args": (v11 /*: any*/),
                                            "handle": "connection",
                                            "key": "Cart_entries",
                                            "filters": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "entriesV2",
                                            "storageKey": "entriesV2(first:1000)",
                                            "args": (v11 /*: any*/),
                                            "concreteType": "CartEntryV2Connection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "edges",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "CartEntryV2Edge",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "node",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "CartEntryV2",
                                                            "plural": false,
                                                            "selections": [
                                                                (v1 /*: any*/),
                                                                (v12 /*: any*/),
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "product",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "ProductV2",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v2 /*: any*/),
                                                                        (v17 /*: any*/),
                                                                        (v1 /*: any*/),
                                                                        (v5 /*: any*/),
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "finalPrice",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "images",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "Images",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v4 /*: any*/),
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "alias": null,
                                                                                    "name": "productFront",
                                                                                    "args": null,
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "alias": null,
                                                                                    "name": "productBack",
                                                                                    "args": null,
                                                                                    "storageKey": null
                                                                                },
                                                                                (v1 /*: any*/)
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "productPermissions",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "ProductPermissions",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "alias": null,
                                                                                    "name": "oneCommerce",
                                                                                    "storageKey": null,
                                                                                    "args": null,
                                                                                    "concreteType": "AppProductPermissionsAccess",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v20 /*: any*/)
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "ProductCatalog_Query",
            "id": null,
            "text": "query ProductCatalog_Query(\n  $count: Int\n  $category: String\n  $sortBy: String\n  $filterPrice: [String]\n  $filterByCause: [String]\n  $filterByType: [String]\n  $filterByVarietal: [String]\n  $filterByGiftCategories: [String]\n  $productCategories: [String]\n  $productsExclude: [String]\n  $productsOnly: [String]\n) {\n  viewer {\n    id\n    ...ProductsCatalog_viewer_4muyEu\n  }\n}\n\nfragment ProductsCatalog_viewer_4muyEu on Viewer {\n  id\n  productsBulk(first: 2, productIds: [\"4f3661e6-9d11-43bc-872e-6f4cc1df744f\", \"7e86bc10-4203-4078-a006-ba8394422f20\"]) {\n    edges {\n      node {\n        id\n        productId\n        priceSale\n        images {\n          productCatalog\n          id\n        }\n        price\n        productPermissions {\n          oneCommerce {\n            preferredCustomer {\n              add\n            }\n          }\n        }\n      }\n    }\n  }\n  user {\n    id\n    userId\n    ...ProductListItem_user\n    conciergeUser {\n      id\n      permissions {\n        id\n        oneCommerce {\n          id\n          preferredCustomer {\n            access\n          }\n        }\n      }\n    }\n    permissions {\n      id\n      oneCommerce {\n        id\n        ceo {\n          access\n        }\n        preferredCustomer {\n          access\n        }\n      }\n    }\n    conciergeCustomerAccountId\n    shoppingWithCeoUser {\n      id\n      userId\n      firstName\n      lastName\n      profile {\n        id\n        image\n      }\n    }\n    email\n    role\n    products(first: $count, category: $category, sortBy: $sortBy, filterPrice: $filterPrice, filterByCause: $filterByCause, filterByType: $filterByType, filterByVarietal: $filterByVarietal, filterByGiftCategories: $filterByGiftCategories, productCategories: $productCategories, productsExclude: $productsExclude, productsOnly: $productsOnly) {\n      edges {\n        cursor\n        node {\n          id\n          productId\n          name\n          company\n          price\n          priceSale\n          inStockOn\n          inventoryClass\n          inventoryQuantity\n          inventorySKU\n          reviewAverage\n          productURLslug\n          optionsId\n          ranking\n          promoCodeDiscount {\n            case4Cause {\n              case12PriceUSD\n              case6PriceUSD\n              case6SKU\n              case12SKU\n              donationEligible\n            }\n          }\n          options {\n            id\n            optionId\n            optionName\n            choiceStyle\n            options {\n              optionName\n            }\n          }\n          images {\n            productCatalog\n            id\n          }\n          content {\n            summary\n            impactSmall\n            id\n          }\n          ...ProductListItem_product\n          __typename\n        }\n      }\n      pageInfo {\n        hasNextPage\n        hasPreviousPage\n        startCursor\n        endCursor\n      }\n    }\n    cart {\n      id\n      eventId\n      enrollingAsPc\n      taxRate\n      taxTotal\n      totalNumberOfItems\n      subTotalPriceOfItems\n      promoCodeSavings\n      viaQualifiedCartTotal\n      subTotalPriceOfItemsWithPromoCodes\n      entries(first: 1000) {\n        edges {\n          node {\n            id\n            product {\n              id\n              name\n              productId\n              price\n              priceSale\n              promoCodeDiscount {\n                case4Cause {\n                  case12PriceUSD\n                  case6PriceUSD\n                  case6SKU\n                  case12SKU\n                  donationEligible\n                }\n              }\n            }\n            quantity\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n      entriesV2(first: 1000) {\n        edges {\n          node {\n            id\n            quantity\n            product {\n              productId\n              name\n              id\n              price\n              finalPrice\n              images {\n                productCatalog\n                productFront\n                productBack\n                id\n              }\n              productPermissions {\n                oneCommerce {\n                  preferredCustomer {\n                    view\n                    add\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ProductListItem_user on User {\n  id\n  role\n  conciergeCustomerAccountId\n  conciergeUser {\n    id\n    userId\n    permissions {\n      id\n      oneCommerce {\n        id\n        preferredCustomer {\n          access\n        }\n      }\n    }\n    subscriptions {\n      wineClub {\n        enrollmentStatus\n        subscriptionStatus\n        id\n      }\n      id\n    }\n  }\n  cartV2 {\n    id\n    cartId\n    discountQualifiedCartTotal\n    entries(first: 1000) {\n      edges {\n        node {\n          id\n          sku\n          productId\n          quantity\n          productName\n          productURLslug\n          productImageUrl\n          wineBottleQuantity\n          isWinePack\n          priceOriginal\n          priceSale\n          priceDiscount\n          discountEligible\n          priceDiscountPercent\n          hasQualifyingDiscount\n        }\n      }\n    }\n  }\n  subscriptions {\n    wineClub {\n      enrollmentStatus\n      subscriptionStatus\n      id\n    }\n    id\n  }\n  permissions {\n    id\n    oneCommerce {\n      id\n      preferredCustomer {\n        access\n      }\n    }\n  }\n}\n\nfragment ProductListItem_product on Product {\n  id\n  isSubscription\n  productPermissions {\n    oneCommerce {\n      preferredCustomer {\n        view\n        add\n      }\n      default {\n        view\n        add\n      }\n    }\n  }\n  ranking\n  company\n  freeUpsGroundShipping\n  productId\n  name\n  category\n  price\n  priceUSDmin\n  priceUSDmax\n  year\n  priceSale\n  reviewAverage\n  productURLslug\n  parentProduct\n  inventoryText\n  reviewTotal\n  staticUrl\n  images {\n    productCatalog\n    squareFront\n    id\n  }\n  content {\n    impactSmall\n    summary\n    id\n  }\n  promoCodeDiscount {\n    case4Cause {\n      case12PriceUSD\n      case6PriceUSD\n      case6SKU\n      case12SKU\n      donationEligible\n    }\n  }\n  inventoryClass\n  inventorySKU\n  inventoryQuantity\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '781210ab6ca5de41b702df8c065d21ca';
export default node;
